module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-mov-1.bb7a99dc.png";